/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_Link_Web_LoginInputs */

const en_footer_link_web_login = /** @type {(inputs: Footer_Link_Web_LoginInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Web Login`)
};

const es_footer_link_web_login = /** @type {(inputs: Footer_Link_Web_LoginInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acceso Web`)
};

/**
* | output |
* | --- |
* | "Web Login" |
*
* @param {Footer_Link_Web_LoginInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const footer_link_web_login = /** @type {((inputs?: Footer_Link_Web_LoginInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_Link_Web_LoginInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_footer_link_web_login(inputs)
	return en_footer_link_web_login(inputs)
});